__turbopack_context__.v({
  "LinkShareButton": "style-module-scss-module__hmcp4q__LinkShareButton",
  "label": "style-module-scss-module__hmcp4q__label",
});
